<template>
  <div>
    <a-card style="margin: 10px 0px">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchData"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>
    <a-card style="margin: 10px 0px">
      <TableView
        bordered
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :data="tableData"
        @handlePagination="handleClickPage"
        :scroll="SCROLL"
      >
        <!--书面担保金额 writtenAmount -->
        <template v-slot:writtenAmount="{ tableRow }">
          <span>{{ tableRow.writtenAmount | formatAmount }}</span>
        </template>
        <!--担保金额(元) slot-->
        <template v-slot:validAmount="{ tableRow }">
          <span>{{ tableRow.validAmount | formatAmount }}</span>
        </template>
        <template v-slot:action="{ tableRow }">
          <a href="javascript:void(0)">
            <a-popover title="点击下载" trigger="hover">
              <template slot="content">
                <div v-if="tableRow.attachments.length">
                  <p v-for="item in tableRow.attachments" :key="item.id">
                    <a herf="javascript:;" @click="handleView(item.id)">
                      {{ tableRow.attachments.length && item.fileName }}
                    </a>
                  </p>
                </div>
                <a-empty v-else />
              </template>
              <span href="javascript:;" size="small" type="link">
                下载
              </span>
            </a-popover>
          </a>
          <a
            href="javascript:void(0)"
            @click="goDeatil(tableRow)"
            style="margin-left:10px;"
          >
            查看
          </a>
        </template>
      </TableView>
    </a-card>
  </div>
</template>

<script>
import { agetAssurance, downUpload } from './api'
import { SearchView, TableView } from 'lxfintech-fe'
import moment from 'moment'
import mixin from './mixin'
export default {
  data() {
    //这里存放数据
    return {
      tableLoading: true,
      SCROLL: { x: 2600 },
      tableData: [],
    }
  },
  mixins: [mixin],
  components: { SearchView, TableView },

  //方法集合
  methods: {
    //查看审批页
    goDeatil(data) {
      this.$router.push({
        path: `/Item/guarantee-detail/guarantee-approval/${data.bpmId}`,
        query: {
          companyCode: data.companyCode,
          typeStr: 2,
        },
      })
    },

    // 下载附件
    async handleView(id) {
      await downUpload(id)
    }, // 获取表格数据
    async _getTableData() {
      this.tableLoading = true
      try {
        const { current, pageSize } = this.pageData
        const query = {
          ...this.searchData,
          size: pageSize,
          current,
        }
        if (query.approveRangeDate.length) {
          query.approveIndate = moment(query.approveRangeDate[0]).format(
            'YYYY-MM-DD',
          )
          query.approveEnddate = moment(query.approveRangeDate[1]).format(
            'YYYY-MM-DD',
          )
        }
        if (query.applyRangeDate.length) {
          query.applyIndate = moment(query.applyRangeDate[0]).format(
            'YYYY-MM-DD',
          )
          query.applyEnddate = moment(query.applyRangeDate[1]).format(
            'YYYY-MM-DD',
          )
        }
        delete query.applyRangeDate
        delete query.approveRangeDate
        const {
          data: { total, records },
        } = await agetAssurance(query)
        this.pageData.total = total
        this.tableData = records
        this.tableData.map(item => {
          item.expireDate = moment(item.expireDate).format('YYYY-MM-DD')
          if (item.applyDate) {
            item.applyDate = moment(item.applyDate).format('YYYY-MM-DD')
          }
          if (item.approveDate) {
            item.approveDate = moment(item.approveDate).format('YYYY-MM-DD')
          }
          item.efficientDate = moment(item.efficientDate).format('YYYY-MM-DD')
        })
        this.tableLoading = false
      } catch (error) {
        console.log(error)
      }
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getTableData()
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
